import { lazy } from 'react'

export const DeactivateAppModalAsync = lazy(() =>
	import('./DeactivateAppModal').then((module) => ({
		default: module.DeactivateAppModal
	}))
)